import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaArrowRight, FaPlay } from 'react-icons/fa';
import './Hero.css';

const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      id: 1,
      title: "Transforme sua ideia em um produto real",
      subtitle: "Da ideia a solução, juntos do início ao fim",
      description: "Ajudamos empreendedores, startups e empresas a desenvolver soluções digitais sob medida, com agilidade, inovação e foco no resultado.",
      image: "https://img.freepik.com/fotos-gratis/experiencia-em-programacao-com-pessoa-a-trabalhar-com-codigos-no-computador_23-2150010125.jpg"
    },
    {
      id: 2,
      title: "Tecnologia feita para o seu negócio",
      subtitle: "Software sob medida, pensado para escalar com você",
      description: "Desenvolvemos sistemas personalizados que se adaptam às necessidades específicas da sua empresa.",
      image: "https://images.unsplash.com/photo-1555066931-4365d14bab8c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80"
    },
    {
      id: 3,
      title: "Inovação e qualidade em cada projeto",
      subtitle: "Qualidade técnica que gera impacto",
      description: "Nossa equipe aplica boas práticas para entregar soluções escaláveis, seguras e com alto padrão de qualidade.",
      image: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80"
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 10000);

    return () => clearInterval(timer);
  }, [slides.length]);

  const scrollToContact = () => {
    const element = document.getElementById('contato');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="inicio" className="hero">
      <div className="hero-carousel" role="region" aria-label="Carrossel de destaques do site">
        <AnimatePresence mode="wait">
          <motion.div
            key={currentSlide}
            className="hero-slide"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
            style={{
              backgroundImage: `linear-gradient(rgba(0, 129, 165, 0.7), rgba(0, 175, 239, 0.7)), url(${slides[currentSlide].image})`
            }}
          >
            <div className="container">
              <div className="hero-content">
                <motion.div
                  className="hero-text"
                  initial={{ y: 50, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ delay: 0.2, duration: 0.8 }}
                >
                  <h1 className="hero-title">{slides[currentSlide].title}</h1>
                  <p className="hero-subtitle">{slides[currentSlide].subtitle}</p>
                  <p className="hero-description">{slides[currentSlide].description}</p>
                  
                  <div className="hero-buttons">
                    <button className="btn btn-primary" onClick={scrollToContact}>
                      Fale conosco
                      <FaArrowRight />
                    </button>
                    <button className="btn btn-secondary" onClick={() => {
                      const element = document.getElementById('solucoes');
                      if (element) {
                        element.scrollIntoView({ behavior: 'smooth' });
                      }
                    }}>
                      <FaPlay />
                      Explore nossas soluções
                    </button>
                  </div>
                </motion.div>
              </div>
            </div>
          </motion.div>
        </AnimatePresence>

        <div className="hero-indicators">
          {slides.map((_, index) => (
            <button
              key={index}
              className={`hero-indicator ${index === currentSlide ? 'active' : ''}`}
              onClick={() => setCurrentSlide(index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero; 